export default {
  type: {
    lang: 'kr',
  },
  header: {
    help: '도움말',
    alliance: '제휴',
    pricing: '가격',
    downloadApp: 'APP 다운로드',
  },
  mailForm: {
    address: '서울 마포구 월드컵북로396, 8F 804',
    phrase_01: '성공적인 비즈니스를 위한 귀사의 소중한 제안을 기다립니다.',
    phrase_02:
      '제휴 내용에 따라 담당자에게 전달되며, 검토 후 회신 드리도록 하겠습니다.',
    co_name: '업체명',
    poc: '연락처',
    email: 'E-mail',
    detail: '상세 내용',
    send: '문의하기',
  },
  home: {
    qr: {
      title: '모바일 App 다운로드',
      caption: 'QR Code를 스캔하시면 앱을 설치할 수 있습니다.',
    },
    macOS: {
      title: 'macOS 다운로드',
      caption:
        'Mac OS는 당분간 시범 서비스로 제공됩니다. 일부 기종(M1, M2 제외)은 서비스가 지원되지 않을 수 있습니다. 문의사항은 레플팀으로 연락 주세요.',
      button: '다운로드 받기',
    },
    banner: {
      mainTit: '모두 준비되셨나요?',
      subTit: '레플에서 메타버스를 경험하세요!',
      downloadApp: 'APP 다운로드',
      downloadMobileApp: 'Android App',
      downloadPcApp: 'Windows App',
      downloadiOSApp: 'iOS App',
      downloadiOSAppUrl: 'https://apps.apple.com/kr/app/id1604332618',
      downloadMacOSApp: 'MacOS App',
      downloadMacOSAppUrl: '',
      downloadGuide01: 'Mac OS App 7월 출시 예정',
      downloadGuide02: '아바타 2.0 업데이트 예정 (7월 19일)',
    },
    event: {
      ssu: '숭실대 SSU-PARK',
      ssu_desc: '숭실대학교 메타버스 입학 상담 및 캠퍼스투어',
      gwhs: '대구 경원고등학교 온라인 축제',
      gwhs_desc: '대구 경원고등학교 온라인 메타버스 축제',
      ccei: '인천 창조경제혁신센터 성과 공유회',
      ccei_desc: '인천 창조경제혁신센터 성과 공유회 행사',
      arir: '아리랑국제방송 메타버스 미디어관 생중계',
      arir_desc: '3.1일 삼일절 독도 미디어관 실시간 생중계 방송',
      kmeb: 'K-Metaverse Expo Busan 2022',
      kmeb_desc:
        '가상 부산에서 열린 메타버스/VR/XR 등 전문 분야의 전시/컨퍼런스',
      kmes: 'KME & KMF 2022',
      kmes_desc:
        '가상 서울에서 열린 메타버스/VR/XR 등 전문 분야의 전시/컨퍼런스',
      posid: '우체국금융개발원 비전선포식',
      posid_desc: '우체국금융개발원 노사공동 비전선포식 행사',
      dokdo: '독도의 날, 플래시몹 이벤트',
      dokdo_desc:
        '아리랑국제방송에서 독도의 날을 맞아 독도 플래시몹 이벤트 진행',
      jsar: '한국문화체험, 정선 아리랑 이벤트',
      jsar_desc:
        '아리랑국제방송에서 정선 아리랑 한 목소리, 한복 체험이 가능한 이벤트 진행',
      ssu2: '숭실대학교 예비대학 행사',
      ssu2_desc:
        '숭실대 가상 캠퍼스 체험, 퀘스트 해결을 통해 자연스러운 학교 역사 교육 및 교내 생활정보 전달',
      popup_ssu_tit: '숭실대',
      popup_ssu_txt: '숭실대학교 메타버스 입학상담 및 캠퍼스투어 진행',
      popup_gwhs_tit: '대구 경원고등학교 온라인 축제',
      popup_gwhs_txt: '대구 경원고등학교 온라인 메타버스 축제 진행',
      popup_ccei_tit: '인천 창조경제혁신센터 성과 공유회',
      popup_ccei_txt: '인천 창조경제혁신센터 성과 공유회 행사 진행',
      popup_arir_tit: '아리랑국제방송 메타버스 미디어관 생중계',
      popup_arir_txt: '3.1일, 삼일절 독도 미디어관 실시간 생중계 방송',
      popup_kmeb_tit: 'K-Metaverse Expo Busan 2022',
      popup_kmeb_txt:
        '가상 부산에서 열린 메타버스/VR/XR 등 전문 분야의 전시/컨퍼런스',
      popup_kmes_tit: 'KME & KMF 2022',
      popup_kmes_txt:
        '가상 서울에서 열린 메타버스/VR/XR 등 전문 분야의 전시/컨퍼런스',
      popup_posid_tit: '우체국금융개발원 비전선포식',
      popup_posid_txt: '우체국금융개발원 노사공동 비전선포식 행사',
      popup_dokdo_tit: '독도의 날, 플래시몹 이벤트',
      popup_dokdo_txt:
        '아리랑국제방송에서 독도의 날을 맞아 독도 플래시몹 이벤트 진행',
      popup_jsar_tit: '한국문화체험, 정선 아리랑 이벤트',
      popup_jsar_txt:
        '아리랑국제방송에서 정선 아리랑 한 목소리, 한복 체험이 가능한 이벤트 진행',
      popup_ssu2_tit: '숭실대학교 예비대학 행사',
      popup_ssu2_txt:
        '숭실대 가상 캠퍼스 체험, 퀘스트 해결을 통해 자연스러운 학교 역사 교육 및 교내 생활정보 전달',
      date: '행사 일시',
      details: '행사 내용',
      link: '보도 자료',
      link_txt: '링크',
    },
    promo: {
      phrase: '상상 속 가상이 일상이 되는 길',
    },
    service: {
      mainTit: '레디플레이 서비스',
      subTit_01: '참여자 간 커뮤니케이션 강화',
      subTit_02: '실시간 / 비실시간 동시 지원',
      subTit_03: '셀피 3d 아바타 자동 제작',
      subTit_04: '다양한 3d 가상 공간 템플릿',
      subTit_05: '온라인 미팅으로서의 토탈 솔루션',
      subTit_06: '녹화 서비스 제공',
      text_01:
        '아이컨택, 바디랭귀지 등을 통해 일방적인 자료 전달이 아닌 서로간의 소통을 도모하며 명함 교환과 게시판을 통해 커뮤니티로서의 역할도 제공합니다.',
      text_02:
        '리얼 3D 오디오를 지원하여 보다 생생하게 실시간 소통을 진행할 수 있습니다. 또한, 행사가 끝난 후에도 게시판을 통해 지난 내용을 확인할 수 있습니다.',
      text_03:
        '셀피를 통해 아바타를 3D로 제작하여 실제 대면하는듯한 느낌을 제공합니다.',
      text_04:
        '다양한 3D 가상공간들을 제공하여 주제와 톤에 맞게 장소를 고를 수 있습니다.',
      text_05:
        '이미지, PDF, 영상, 유튜브 링크 등을 실시간으로 공유할 수 있습니다.',
      text_06:
        '전체적인 행사 흐름에 대한 기록을 남겨 추가 콘텐츠 생산을 할 수 있습니다.',
    },
    devices: {
      mainTit: '지원 기기',
      pcDesc_01:
        '기관, 학교, 기업 등 누구든 사용 가능하며, PC 화면 공유, 화상채팅 기능 등을',
      pcDesc_02: '사용하여 실시간 상담, 미팅을 진행할 수 있습니다.',
      pcConfig_category_tit: '구분',
      pcConfig_category_01: '운영 체제',
      pcConfig_category_02: '그래픽 카드',
      pcConfig_category_03: 'CPU',
      pcConfig_category_04: 'DirectX',
      pcConfig_category_05: '메모리',
      pcConfig_category_06: 'HDD',
      pcMinConfig_tit: 'PC 최소 사양',
      pcMinConfig_desc_01: 'Windows 7 64bit 이상',
      pcMinConfig_desc_02: 'Geforce GT 740 AMD Radeon HD 7750',
      pcMinConfig_desc_03: 'intel Core i3-4340 AMD FX 4330',
      pcMinConfig_desc_04: 'DirectX 11 이상 ',
      pcMinConfig_desc_05: '8G',
      pcMinConfig_desc_06: '20G 이상 여유 공간',
      pcRecConfig_tit: 'PC 권장 사양',
      pcRecConfig_desc_01: 'Windows 7 64bit 이상',
      pcRecConfig_desc_02: 'Geforce GTX 1060 3G AMD Radeon RX 580 4G',
      pcRecConfig_desc_03: 'intel Core i5-6600 AMD Ryzen 5 1600',
      pcRecConfig_desc_04: 'DirectX 11 이상 ',
      pcRecConfig_desc_05: '16G',
      pcRecConfig_desc_06: '20G 이상 여유 공간',
      mobileConfig: 'Android 8.0 이상',
      mobileDesc_01:
        '모바일로 편리하게 언제 어디서든 간편하게 이용할 수 있습니다.',
      mobileDesc_02:
        '아바타 만들기, 자료 공유, 게시판 방명록, 다양한 콘텐츠를 경험할 수 있습니다.',
      vrDesc_01: 'VR을 이용하여 실제 해당 공간에 있는 것처럼 느낄 수 있습니다.',
      vrDesc_02:
        '가상 공간에서 친구들과 대화하고, 메타버스를 즐기실 수 있습니다.',
    },
  },
  help: {
    banner: {
      toolTip: '안내 가이드와 제작 가이드를 읽어보세요.',
      manual: '안내 가이드',
      guidance: '제작 가이드',
      manual_url:
        'https://www.evernote.com/shard/s542/sh/5211005c-1cf4-e4aa-a010-c3918bd41145/1K461TIQkem0eWt4S_crYZE1NakIkdCofysMbiM-XVFBwVZPr_ta0hT2Dw',
    },
    faq: {
      mainTit: '자주 하는 질문',
      qn_01: '스크린에서 어떤 파일을 공유 할 수 있나요?',
      ans_01:
        '새로워진 Ready Play에서는 Image, PDF 파일과 비디오 영상, Youtube 영상, Youtube Live 영상을 지원합니다. 다만 영상은 Full HD 해상도까지, H264 코덱을 사용된 영상이어야 공유가 가능하니 참고해 주세요',
      qn_02: '회원가입 시 어떤 종류의 SNS를 이용할 수 있나요?',
      ans_02:
        '현재는 페이스북 계정으로 회원가입을 하실 수 있습니다. 차후 늘려나갈 예정입니다.',
      qn_03: '여러 기기에 중복으로 로그인할 수 있나요?',
      ans_03: '같은 계정으로 다른 기기에 중복으로 로그인이 불가능합니다.',
      qn_04: '회원 탈퇴 후 재가입할 수 있나요?',
      ans_04:
        ' 네, 회원 탈퇴 후 다시 가입하실 수 있습니다. 다만 이전에 저장된 정보는 모두 삭제됩니다.',
      qn_05: '메타버스 모임은 몇 명까지 참여할 수 있나요?',
      ans_05:
        '메타버스 모임(World)의 최대 참여 인원은 131명 입니다 (방장 포함 인원수). 단, 아바타로 보이는 인원(Speaker)은 30명이며, 참여자(Listener)는 100명입니다. 즉, 아바타가 없는 참여자(Listener)는 아바타를 보고, 듣는 것은 가능하지만 아바타로 보여지고, 말을 할 수는 없습니다.',
      qn_06: '회원가입을 해야만 메타버스 모임에 참여할 수 있나요?',
      ans_06:
        '네, 서비스의 모든 기능은 회원가입을 해야만 이용하실 수 있습니다.',
      qn_07: '누구나 메타버스 모임을 만들 수 있나요?',
      ans_07:
        '네, 메타버스 모임은 누구나 무료로 자유롭게 만들고 참여하실 수 있습니다.',
      qn_08: '탈퇴 후 다시 가입하면, 원래 있던 친구들은 사라지나요?',
      ans_08: '네, 회원 탈퇴 시 모든 정보가 삭제되어 친구 정보도 사라집니다.',
      qn_09: '어떤 휴대폰에서 이용할 수 있나요?',
      ans_09:
        '안드로이드 8.0이상의 스마트폰에서 이용하실 수 있습니다. iOS 개발은 진행중에 있습니다.',
      qn_10: '메타버스 모임이 무엇인가요?',
      ans_10:
        '메타버스 세상의 가상 공간으로 컨퍼런스 홀, 로비, 교실 등 다양한 공간이 마련되어 있습니다. 메타버스 모임에서 음성 채팅을 통해 상대방과 대화하실 수 있습니다.',
      qn_11: '음성 채팅은 누구와 할 수 있나요?',
      ans_11: '소셜 월드에 있는 아바타와 대화하실 수 있습니다.',
      qn_12: '내가 초대한 사람만 컨퍼런스에 입장할 수 있나요?',
      ans_12:
        '비밀번호를 설정하시면 비밀번호를 아는 사람만 입장하실 수 있습니다. 공개된 메타버스 모임 룸은 누구나 참여하실 수 있습니다.',
      qn_13: '메타버스 모임(World)에서 발표 자료를 크게 볼 수 있나요?',
      ans_13:
        '네, 보여지는 스크린 화면을 선택하면 발표 자료를 크게 보실 수 있습니다.',
      qn_14: '발표 자료는 어떻게 불러오나요?',
      ans_14:
        '스크린 화면 우측 상단에 있는 + 버튼을 누르면, 자료 불러오기 창이 나옵니다.',
      qn_15: '발표 자료의 화면은 누구나 넘길 수 있나요?',
      ans_15:
        '아니요, 발표자로 지정된 이용자만 발표 자료를 넘기실 수 있습니다.',
      qn_16: '속도가 느려진 것 같아요.',
      ans_16:
        '업데이트 후 처음 사용하는 경우 느려질 수 있습니다. 앱을 다시 시작해 보세요. 이후에도 같은 문제가 반복되면 고객 센터로 문의해 주시기 바랍니다.',
      qn_17: '궁금한 점이 있거나 문의 사항이 있으면 어디로 연락해야 하나요?',
      ans_17_f: 'help@readypaly.co.kr',
      ans_17_s: '로 이메일을 보내주시면 됩니다.',
      qn_18:
        '모임을 시작하려는데, 좌중이 어수선해서 조용히 시키고 싶은데 어떻게 하나요?',
      ans_18:
        ' 좌측 상단 참여자 리스트를 클릭하여 하단에 있는 마이크 All/Off 를 누르시면 됩니다.',
      qn_19:
        '모임 진행 중에 참여자가 실수로 마이크를 On 해두어서 잡음이 들어와요. 특정 사용자의 마이크만 끌 수 있나요?',
      ans_19:
        '좌측 상단 참여자 리스트에서 마이크가 켜져 있는 사람을 확인하고, 마이크 버튼을 클릭하여 음소거 시킬 수 있습니다. 해당 유저는 본인 스스로 마이크를 다시 킬 수 있습니다.',
      qn_20: '스크린 화면이 작아서 잘 안 보여요.',
      ans_20: '스크린 화면을 클릭할 경우 전체화면으로 보실 수 있습니다.',
    },
  },
  alliance: {
    banner: {
      mainTit_01: '성공적인 비즈니스를 위한',
      mainTit_02: '귀사의 소중한 제안을 기다립니다.',
      toolTip_01: '무료 투어 공간에서 레디플레이 공간과 기능을 체험해보세요!',
      toolTip_02: '레디플레이 활용 방법은 언제든지 문의주시기 바랍니다.',
      tour: '투어하기',
      partership: '제휴맺기',
    },
    space: {
      mainTit_01: '기업, 학교, 관공서 등',
      mainTit_02: '필요한 공간을 만들어보세요.',
      subTxt_01: '제공되는 가상 배경 템플릿 외에',
      subTxt_02: '행사의 컨셉에 맞는 가상 공간 제작이 가능합니다.',
    },
    confer: {
      mainTit_01: '가상 공간에서',
      mainTit_02: '현실감',
      mainTit_03: '있는',
      mainTit_04: '행사를 진행해보세요.',
      subTxt_01: '발표하는 강연자의 얼굴 또는 실시간 PC 화면 공유 기능으로',
      subTxt_02: '생생하고 전달력 높은 화상 회의가 가능합니다.',
    },
    avatar: {
      mainTit_01: '알리고자 하는 브랜드 • 제품을',
      mainTit_02: '아바타 파츠',
      mainTit_03: '로 제작할 수 있어요.',
      mainTit_04: '',
      mainTit_05: '',
      subTxt_01: '커스터마이징한 3D 아바타로',
      subTxt_02: '브랜딩 효과를 극대화 시킬 수 있습니다.',
    },
  },
  pricing: {
    banner: {
      subTit_01: '언제, 어디서나 Ready Play',
      subTit_02: '이벤트에 맞는 공간과 기능을 사용해보세요.',
      toolTip: '자세한 비용이 궁금하시다면 언제든지 연락주세요!',
      contact: '견적 문의',
    },
    plan: {
      mainTit: '요금제',
      mainDesc_01: '모든 요금제는 이벤트 1개 개최 기준입니다.',
      mainDesc_02: 'VAT 별도',
      standTit_01: '요금제',
      standTit_02: '항목',
      standTit_03: '기능설명',
      standTit_04: '제공사항',
      avatar: '아바타',
      vSpace: '가상공간',
      function: '기능',
      participants: '참가인원',
      duration: '가상공간 유지기간',
      report: '통계',
      av_td_01: '3D 아바타 (기본 아바타 / 유저 셀피 제작)',
      vs_td_01: '기본 가상 공간 템플릿 제공',
      vs_td_02:
        '가상공간 개설 (공개 ・ 비공개 ・ 이벤트 설정 ・ 공지사항 등록)',
      vs_td_03: '가상공간 검색 (제목 ・ 유저 취향별)',
      vs_td_04: '게시판 ・ 방명록',
      vs_td_05: '가상 공간 내 홍보물 설치',
      vs_td_06: '최대 3개',
      fc_td_01: '음성 / 텍스트 채팅 (+이모티콘)',
      fc_td_02: '파일 공유',
      fc_td_03: '영상 스트리밍',
      fc_td_04: '친구 추가 (팔로우 ・ 팔로잉)',
      fc_td_05: '가상 공간 내 친구 초대 / 강퇴',
      fc_td_06: '지난 프로그램 다시 보기',
      fc_td_07: '화상 채팅',
      fc_td_08: '이벤트 녹화',
      fc_td_09: '1명',
      fc_td_10: '편집 제외',
      pc_td_01: '개별 가상 공간당 접속 가능 인원',
      pc_td_02: '100명',
      dr_td_01: '행사 종료 후 가상공간 유지 기간',
      dr_td_02: '1개월',
      rp_td_01: '통계 자료 항목',
      rp_td_02: '접속 인원',
      cms_td_01: '관리자 페이지',
      optTit_01: '커스터마이징',
      custom_td_01: '플레이월드 신규 제작',
      custom_td_02: '아바타 신규 제작',
      custom_td_03: '아바타 파츠 신규 제작',
      custom_td_04: '상 ・ 하의 각 1개',
      custom_td_05: '2 SET 제작',
      notice: 'Option 항목은 작업 범위에 따라 추가 비용이 발생합니다.',
    },
  },
};
